import logo from "./logo.svg";
import "./App.css";
import React from "react";
import About from "./components/About";
import Contact from "./components/Contact";
import Navbar from "./components/Navbar";
import Projects from "./components/Projects";
import Skills from "./components/Skills";
import Testimonials from "./components/Testimonials";
import Developers from "./components/Developers";

function App() {
	return (
		<main className="text-gray-400 bg-gray-900 body-font">
			<Navbar />
			<About />
			<Projects />
			<Skills />
			<Testimonials />
			<Developers />
			<Contact />
		</main>
	);
}

export default App;

